
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","d":"M9.997 10.21h19.622v2.438H9.997z"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M9.497 7.595h7.734v1.332H9.497zM9.497 20.066h5.644v1.332H9.497z"}}),_c('circle',{attrs:{"cx":"11.215","cy":"24.015","r":"1.219","stroke":"#234652"}}),_c('circle',{attrs:{"cx":"19.807","cy":"24.015","r":"1.219","stroke":"#234652"}}),_c('circle',{attrs:{"cx":"15.511","cy":"24.015","r":"1.719","fill":"#D0EFEC"}}),_c('circle',{attrs:{"cx":".975","cy":".975","r":".5","stroke":"#234652","stroke-width":".95","transform":"matrix(1 0 0 -1 14.536 24.99)"}}),_c('circle',{attrs:{"cx":"24.104","cy":"24.015","r":"1.219","stroke":"#234652"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M10.001 28.53h10.141v4.035H10.001z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M9.997 28.759h8.686v2.438H9.997zM29.618 15.544v2.438H9.997v-2.438z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M33.285 17.815V5.245a2 2 0 0 0-2-2H8.47a2 2 0 0 0-2 2v29.729a2 2 0 0 0 2 2h14.997"}}),_c('circle',{attrs:{"cx":"32.369","cy":"38.038","r":"3.664","fill":"#D0EFEC"}}),_c('circle',{attrs:{"cx":"33.285","cy":"36.511","r":"7.744","stroke":"#234652"}}),_c('circle',{attrs:{"cx":"33.285","cy":"36.511","r":"2.859","stroke":"#234652"}}),_c('path',{attrs:{"stroke":"#234652","d":"M28.705 30.1v-5.802a4.58 4.58 0 1 1 9.16 0v5.801"}}),_c('path',{attrs:{"stroke":"#234652","d":"M30.537 28.878v-4.58a2.748 2.748 0 0 1 5.496 0v4.58"}}),_c('circle',{attrs:{"cx":"33.285","cy":"36.511","r":"5.301","stroke":"#234652","stroke-dasharray":"1 4"}}),_c('path',{attrs:{"stroke":"#234652","d":"M27.061 15.044v3.438"}})])
          )
        }
      }
    